import { toBackendTimestamp } from '@/utils/api/toBackendTimestamp'

import type { OrdersFilters, OrdersListParams } from '../types/orders.types'

const toSearchParam = (value: string) => value.trim() || undefined

export const toOrdersListParams = (
  filters: OrdersFilters
): OrdersListParams => ({
  orderType: filters.orderType,
  createdAtOrderByType: 'DESC',
  client: filters.clientId,
  query: toSearchParam(filters.query),
  productQuery: toSearchParam(filters.productQuery),
  acceptableOrderStatuses:
    filters.status === 'ALL' ? undefined : [filters.status],
  createdAtFrom: toBackendTimestamp(filters.dateFrom),
  createdAtTo: toBackendTimestamp(filters.dateTo),
})

export const serializeOrdersParams = (params: Record<string, unknown>) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    searchParams.append(
      key,
      Array.isArray(value) ? value.join(',') : String(value)
    )
  })
  return searchParams.toString()
}
